module.exports = __webpack_public_path__ + "img/top_info.f1ee9239.png";